/** @format */

import React from "react";

import { ReactComponent as CaretUp } from "bootstrap-icons/icons/chevron-up.svg";
import { ReactComponent as CaretDown } from "bootstrap-icons/icons/chevron-down.svg";
import { ReactComponent as Delete } from "bootstrap-icons/icons/trash.svg";
import { ReactComponent as Duplicate } from "../../assets/icons/duplicate.svg";
import { ReactComponent as Edit } from "bootstrap-icons/icons/pencil.svg";
import { Action, setShowDeleteModal } from "../deleteModal/deleteModalSlice";
import { useDispatch } from "react-redux";
import "./ActionButtons.scss";
import { useAppSelector } from "../../app/hooks";
import { selectIsEditable, selectIsEditing } from "../editable/editableSlice";
import { setShowContentEditor } from "../contentEditor/contentEditorSlice";
import { useLocale } from "../i18n/hooks";
import { useParams } from "react-router-dom";
import {
  moveCard as moveResourceCard,
  moveLesson as moveResourceLesson,
} from "../resources/ResourceFunctions";
import {
  moveCard as moveUserResourceCard,
  moveLesson as moveUserResourceLesson,
} from "../userResources/userResourceFunctions";
import FeatureFlag from "../featureFlag/FeatureFlag";

type Props = {
  action: Action;
  itemUUID: string;
  parentUUID: string;
  className?: string;
  tools: Array<"order" | "delete" | "edit" | "copy">;
};

const ActionButtons: React.FC<Props> = ({
  action,
  itemUUID,
  className,
  tools,
}) => {
  const dispatch = useDispatch();
  const isEditable = useAppSelector(selectIsEditable() && selectIsEditing());
  const locale = useLocale();

  const { resourceId, copy, lessonId, pageId, userId } = useParams();

  const lessonIndex = Number(lessonId);
  const sublessonIndex = Number(pageId);

  const moveItem = async (direction: "move-up" | "move-down") => {
    if (action === "card" && resourceId) {
      if (userId) {
        if (copy)
          moveUserResourceCard(
            resourceId,
            lessonIndex,
            sublessonIndex,
            itemUUID,
            direction,
            locale,
            Number(copy),
            userId,
          );
      } else {
        moveResourceCard(
          resourceId,
          lessonIndex,
          sublessonIndex,
          itemUUID,
          direction,
          locale,
        );
      }
    }

    if (action === "lesson" && resourceId) {
      if (userId) {
        if (copy)
          moveUserResourceLesson(
            resourceId,
            direction,
            itemUUID,
            Number(copy),
            locale,
            userId,
          );
      } else {
        moveResourceLesson(resourceId, direction, itemUUID);
      }
    }
  };

  const toolAction = (tool: "order" | "delete" | "edit" | "copy") => {
    switch (tool) {
      case "order":
        return (
          <>
            <CaretDown
              className="change-position"
              onClick={() => moveItem("move-down")}
            />
            <CaretUp
              className="change-position"
              onClick={() => moveItem("move-up")}
            />
          </>
        );
      case "delete":
        return (
          <Delete
            onClick={() =>
              dispatch(setShowDeleteModal({ action: action, itemId: itemUUID }))
            }
          />
        );
      case "copy":
        return <Duplicate />;
      case "edit":
        return (
          <Edit
            onClick={() =>
              dispatch(
                setShowContentEditor({ action: action, itemId: itemUUID }),
              )
            }
          />
        );
    }
  };

  return isEditable ? (
    <FeatureFlag flag={["editable"]}>
      <div
        className={`action-buttons d-flex position-absolute top-0 end-0 gap-2 justify-content-end ${
          className ?? ""
        }`}
      >
        {tools.map(
          (tool: "order" | "delete" | "edit" | "copy", index: number) => (
            <div key={index} className=" d-flex gap-2">
              {toolAction(tool)}
            </div>
          ),
        )}
      </div>
    </FeatureFlag>
  ) : (
    <></>
  );
};

export default ActionButtons;
